var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagIrn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2112 3649)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_474",
    "data-name": "Ret\\xE2ngulo 474",
    width: 102.857,
    height: 60,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_IRN",
    transform: "translate(-2112 -3649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_ira",
    transform: "translate(2090.596 3649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_471",
    "data-name": "Ret\\xE2ngulo 471",
    width: 102.857,
    height: 60,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_472",
    "data-name": "Ret\\xE2ngulo 472",
    width: 102.857,
    height: 20.053,
    transform: "translate(0)",
    fill: "#49a044"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_473",
    "data-name": "Ret\\xE2ngulo 473",
    width: 102.857,
    height: 20.039,
    transform: "translate(0 39.961)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7011",
    "data-name": "Caminho 7011",
    d: "M257.658,13.286l-1.084.886.2,14.173.887,1.03.892-1.03.2-14.173Z",
    transform: "translate(-206.237 9.495)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_802",
    "data-name": "Grupo 802",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_801",
    "data-name": "Grupo 801",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7012",
    "data-name": "Caminho 7012",
    d: "M260.317,12.407a1.492,1.492,0,0,1-2.064.49c-.036-.024-.084-.048-.115-.072a1.515,1.515,0,0,1-2.106-.3c-.019-.036-.055-.084-.079-.12a2.183,2.183,0,1,0,4.364,0",
    transform: "translate(-206.711 8.866)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7013",
    "data-name": "Caminho 7013",
    d: "M262.207,13.559A8.852,8.852,0,0,1,254.03,27.6a8.213,8.213,0,0,0,8.177-14.043",
    transform: "translate(-208.056 9.69)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7014",
    "data-name": "Caminho 7014",
    d: "M256.9,13.559A8.853,8.853,0,0,0,265.083,27.6,8.214,8.214,0,0,1,256.9,13.559",
    transform: "translate(-208.209 9.69)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7015",
    "data-name": "Caminho 7015",
    d: "M259.392,13.4a8.859,8.859,0,0,1,1.958,12.378c-.144.192-.3.4-.449.562a7.015,7.015,0,0,0-1.509-12.94",
    transform: "translate(-204.224 9.58)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7016",
    "data-name": "Caminho 7016",
    d: "M257.184,13.4a8.856,8.856,0,0,0-1.951,12.378,5,5,0,0,0,.454.562,7.015,7.015,0,0,1,1.5-12.94",
    transform: "translate(-209.508 9.58)",
    fill: "#c7001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7017",
    "data-name": "Caminho 7017",
    d: "M227.349,12.122h.468v-.946h1.406v.946h2.334V10.7h-1.4v.478h.933v.48h-1.4V10.7h-2.34Zm.94,0h.466v-.466h-.466Zm-.94-1.9h6.082V9.74h-6.082Zm6.082,1.9h-1.4V10.7H233.9V9.74h.468v1.915h.466V9.74h.466v1.915h.473V9.74h.461v2.382H233.9v-.946h-1.4v.48h.933Z",
    transform: "translate(-227.123 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7018",
    "data-name": "Caminho 7018",
    d: "M232.806,12.122h.473v-.946h1.394v.946h2.334V10.7h-1.4v.478h.933v.48h-1.4V10.7h-2.334Zm.933,0h.466v-.466h-.466Zm-.933-1.9h6.075V9.74h-6.075Zm6.075,1.9h-1.406V10.7h1.867V9.74h.473v1.915h.472V9.74h.461v1.915h.473V9.74h.466v2.382h-2.346v-.946h-1.4v.48h.934Z",
    transform: "translate(-223.223 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7019",
    "data-name": "Caminho 7019",
    d: "M238.258,12.122h.466v-.946h1.4v.946h2.34V10.7h-1.4v.478H242v.48h-1.406V10.7h-2.335Zm.934,0h.466v-.466h-.466Zm-.934-1.9h6.082V9.74h-6.082Zm6.082,1.9h-1.406V10.7H244.8V9.74h.466v1.915h.473V9.74h.473v1.915h.46V9.74h.468v2.382H244.8v-.946h-1.4v.48h.94Z",
    transform: "translate(-219.327 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7020",
    "data-name": "Caminho 7020",
    d: "M243.711,12.122h.466v-.946h1.4v.946h2.34V10.7h-1.408v.478h.935v.48h-1.4V10.7h-2.334Zm.933,0h.466v-.466h-.466Zm-.933-1.9h6.075V9.74h-6.075Zm6.075,1.9H248.38V10.7h1.879V9.74h.466v1.915h.461V9.74h.473v1.915h.466V9.74h.466v2.382h-2.334v-.946h-1.408v.48h.934Z",
    transform: "translate(-215.43 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7021",
    "data-name": "Caminho 7021",
    d: "M249.164,12.122h.468v-.946h1.4v.946h2.34V10.7h-1.406v.478h.94v.48h-1.4V10.7h-2.34Zm.94,0h.461v-.466H250.1Zm-.94-1.9h6.082V9.74h-6.082Zm6.082,1.9H253.84V10.7h1.872V9.74h.468v1.915h.466V9.74h.466v1.915h.466V9.74h.468v2.382h-2.335v-.946h-1.406v.48h.94Z",
    transform: "translate(-211.533 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7022",
    "data-name": "Caminho 7022",
    d: "M254.617,12.122h.468v-.946h1.4v.946h2.339V10.7h-1.4v.478h.929v.48h-1.4V10.7h-2.34Zm.94,0h.461v-.466h-.461Zm-.94-1.9H260.7V9.74h-6.082Zm6.082,1.9h-1.4V10.7h1.867V9.74h.468v1.915h.466V9.74h.468v1.915h.466V9.74h.466v2.382h-2.335v-.946h-1.4v.48h.94Z",
    transform: "translate(-207.636 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7023",
    "data-name": "Caminho 7023",
    d: "M260.069,12.122h.468v-.946h1.406v.946h2.334V10.7h-1.4v.478h.941v.48H262.4V10.7h-2.335Zm.935,0h.473v-.466H261Zm-.935-1.9h6.082V9.74h-6.082Zm6.082,1.9h-1.4V10.7h1.867V9.74h.468v1.915h.466V9.74h.466v1.915h.473V9.74h.461v2.382h-2.335v-.946h-1.394v.48h.928Z",
    transform: "translate(-203.74 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7024",
    "data-name": "Caminho 7024",
    d: "M265.526,12.122h.46v-.946h1.4v.946h2.341V10.7h-1.394v.478h.933v.48H267.86V10.7h-2.334Zm.933,0h.466v-.466h-.466Zm-.933-1.9h6.087V9.74h-6.087Zm6.087,1.9H270.2V10.7h1.867V9.74h.473v1.915h.466V9.74h.461v1.915h.473V9.74h.466v2.382h-2.34v-.946h-1.4v.48h.946Z",
    transform: "translate(-199.84 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7025",
    "data-name": "Caminho 7025",
    d: "M270.979,12.122h.466v-.946h1.4v.946h2.341V10.7h-1.394v.478h.933v.48h-1.413V10.7h-2.334Zm.933,0h.466v-.466h-.466Zm-.933-1.9h6.075V9.74h-6.075Zm6.075,1.9h-1.4V10.7h1.879V9.74h.456v1.915h.478V9.74h.454v1.915h.468V9.74h.478v2.382h-2.335v-.946h-1.411v.48h.933Z",
    transform: "translate(-195.943 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7026",
    "data-name": "Caminho 7026",
    d: "M276.435,12.122h.466v-.946h1.4v.946h2.334V10.7h-1.4v.478h.935v.48h-1.4V10.7h-2.334Zm.933,0h.466v-.466h-.466Zm-.933-1.9h6.075V9.74h-6.075Zm6.075,1.9H281.1V10.7h1.872V9.74h.468v1.915h.466V9.74h.466v1.915h.466V9.74h.468v2.382h-2.335v-.946h-1.4v.48h.934Z",
    transform: "translate(-192.044 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7027",
    "data-name": "Caminho 7027",
    d: "M281.884,12.122h.478v-.946h1.4v.946h2.328V10.7h-1.4v.478h.935v.48h-1.4V10.7h-2.34Zm.945,0h.454v-.466h-.454Zm-.945-1.9h6.075V9.74h-6.075Zm6.075,1.9h-1.4V10.7h1.867V9.74h.48v1.915h.454V9.74h.478v1.915h.466V9.74h.468v2.382h-2.347v-.946h-1.4v.48h.934Z",
    transform: "translate(-188.15 6.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7028",
    "data-name": "Caminho 7028",
    d: "M227.349,12.373h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-227.123 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7029",
    "data-name": "Caminho 7029",
    d: "M232.8,12.373h4.2v-.958h-4.2Zm4.669,0h4.215v-.958h-4.215Z",
    transform: "translate(-223.224 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7030",
    "data-name": "Caminho 7030",
    d: "M238.258,12.373h4.208v-.958h-4.208Zm4.676,0h4.208v-.958h-4.208Z",
    transform: "translate(-219.327 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7031",
    "data-name": "Caminho 7031",
    d: "M243.711,12.373h4.208v-.958h-4.208Zm4.669,0h4.215v-.958H248.38Z",
    transform: "translate(-215.43 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7032",
    "data-name": "Caminho 7032",
    d: "M249.164,12.373h4.208v-.958h-4.208Zm4.674,0h4.208v-.958h-4.208Z",
    transform: "translate(-211.533 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7033",
    "data-name": "Caminho 7033",
    d: "M254.617,12.373h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-207.636 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7034",
    "data-name": "Caminho 7034",
    d: "M260.069,12.373h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-203.74 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7035",
    "data-name": "Caminho 7035",
    d: "M265.526,12.373h4.2v-.958h-4.2Zm4.674,0h4.208v-.958H270.2Z",
    transform: "translate(-199.84 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7036",
    "data-name": "Caminho 7036",
    d: "M270.979,12.373h4.208v-.958h-4.208Zm4.674,0h4.215v-.958h-4.215Z",
    transform: "translate(-195.943 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7037",
    "data-name": "Caminho 7037",
    d: "M276.435,12.373h4.2v-.958h-4.2Zm4.669,0h4.208v-.958H281.1Z",
    transform: "translate(-192.044 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7038",
    "data-name": "Caminho 7038",
    d: "M281.884,12.373h4.208v-.958h-4.208Zm4.676,0h4.215v-.958H286.56Z",
    transform: "translate(-188.15 8.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7039",
    "data-name": "Caminho 7039",
    d: "M227.349,26.246h.468v-.958h1.406v.958h2.334V24.809h-1.4v.478h.933v.48h-1.4v-.958h-2.34Zm.94,0h.466v-.478h-.466Zm-.94-1.9h6.082v-.478h-6.082Zm6.082,1.9h-1.4V24.809H233.9v-.945h.468v1.9h.466v-1.9h.466v1.9h.473v-1.9h.461v2.382H233.9v-.958h-1.4v.48h.933Z",
    transform: "translate(-227.123 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7040",
    "data-name": "Caminho 7040",
    d: "M232.806,26.246h.473v-.958h1.394v.958h2.334V24.809h-1.4v.478h.933v.48h-1.4v-.958h-2.334Zm.933,0h.466v-.478h-.466Zm-.933-1.9h6.075v-.478h-6.075Zm6.075,1.9h-1.406V24.809h1.867v-.945h.473v1.9h.472v-1.9h.461v1.9h.473v-1.9h.466v2.382h-2.346v-.958h-1.4v.48h.934Z",
    transform: "translate(-223.223 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7041",
    "data-name": "Caminho 7041",
    d: "M238.258,26.246h.466v-.958h1.4v.958h2.34V24.809h-1.4v.478H242v.48h-1.406v-.958h-2.335Zm.934,0h.466v-.478h-.466Zm-.934-1.9h6.082v-.478h-6.082Zm6.082,1.9h-1.406V24.809H244.8v-.945h.466v1.9h.473v-1.9h.473v1.9h.46v-1.9h.468v2.382H244.8v-.958h-1.4v.48h.94Z",
    transform: "translate(-219.327 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7042",
    "data-name": "Caminho 7042",
    d: "M243.711,26.246h.466v-.958h1.4v.958h2.34V24.809h-1.408v.478h.935v.48h-1.4v-.958h-2.334Zm.933,0h.466v-.478h-.466Zm-.933-1.9h6.075v-.478h-6.075Zm6.075,1.9H248.38V24.809h1.879v-.945h.466v1.9h.461v-1.9h.473v1.9h.466v-1.9h.466v2.382h-2.334v-.958h-1.408v.48h.934Z",
    transform: "translate(-215.43 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7043",
    "data-name": "Caminho 7043",
    d: "M249.164,26.246h.468v-.958h1.4v.958h2.34V24.809h-1.406v.478h.94v.48h-1.4v-.958h-2.34Zm.94,0h.461v-.478H250.1Zm-.94-1.9h6.082v-.478h-6.082Zm6.082,1.9H253.84V24.809h1.872v-.945h.468v1.9h.466v-1.9h.466v1.9h.466v-1.9h.468v2.382h-2.335v-.958h-1.406v.48h.94Z",
    transform: "translate(-211.533 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7044",
    "data-name": "Caminho 7044",
    d: "M254.617,26.246h.468v-.958h1.4v.958h2.339V24.809h-1.4v.478h.929v.48h-1.4v-.958h-2.34Zm.94,0h.461v-.478h-.461Zm-.94-1.9H260.7v-.478h-6.082Zm6.082,1.9h-1.4V24.809h1.867v-.945h.468v1.9h.466v-1.9h.468v1.9h.466v-1.9h.466v2.382h-2.335v-.958h-1.4v.48h.94Z",
    transform: "translate(-207.636 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7045",
    "data-name": "Caminho 7045",
    d: "M260.069,26.246h.468v-.958h1.406v.958h2.334V24.809h-1.4v.478h.941v.48H262.4v-.958h-2.335Zm.935,0h.473v-.478H261Zm-.935-1.9h6.082v-.478h-6.082Zm6.082,1.9h-1.4V24.809h1.867v-.945h.468v1.9h.466v-1.9h.466v1.9h.473v-1.9h.461v2.382h-2.335v-.958h-1.394v.48h.928Z",
    transform: "translate(-203.74 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7046",
    "data-name": "Caminho 7046",
    d: "M265.526,26.246h.46v-.958h1.4v.958h2.341V24.809h-1.394v.478h.933v.48H267.86v-.958h-2.334Zm.933,0h.466v-.478h-.466Zm-.933-1.9h6.087v-.478h-6.087Zm6.087,1.9H270.2V24.809h1.867v-.945h.473v1.9h.466v-1.9h.461v1.9h.473v-1.9h.466v2.382h-2.34v-.958h-1.4v.48h.946Z",
    transform: "translate(-199.84 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7047",
    "data-name": "Caminho 7047",
    d: "M270.979,26.246h.466v-.958h1.4v.958h2.341V24.809h-1.394v.478h.933v.48h-1.413v-.958h-2.334Zm.933,0h.466v-.478h-.466Zm-.933-1.9h6.075v-.478h-6.075Zm6.075,1.9h-1.4V24.809h1.879v-.945h.456v1.9h.478v-1.9h.454v1.9h.468v-1.9h.478v2.382h-2.335v-.958h-1.411v.48h.933Z",
    transform: "translate(-195.943 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7048",
    "data-name": "Caminho 7048",
    d: "M276.435,26.246h.466v-.958h1.4v.958h2.334V24.809h-1.4v.478h.935v.48h-1.4v-.958h-2.334Zm.933,0h.466v-.478h-.466Zm-.933-1.9h6.075v-.478h-6.075Zm6.075,1.9H281.1V24.809h1.872v-.945h.468v1.9h.466v-1.9h.466v1.9h.466v-1.9h.468v2.382h-2.335v-.958h-1.4v.48h.934Z",
    transform: "translate(-192.044 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7049",
    "data-name": "Caminho 7049",
    d: "M281.884,26.246h.478v-.958h1.4v.958h2.328V24.809h-1.4v.478h.935v.48h-1.4v-.958h-2.34Zm.945,0h.454v-.478h-.454Zm-.945-1.9h6.075v-.478h-6.075Zm6.075,1.9h-1.4V24.809h1.867v-.945h.48v1.9h.454v-1.9h.478v1.9h.466v-1.9h.468v2.382h-2.347v-.958h-1.4v.48h.934Z",
    transform: "translate(-188.15 17.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7050",
    "data-name": "Caminho 7050",
    d: "M227.349,23.984h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-227.123 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7051",
    "data-name": "Caminho 7051",
    d: "M232.8,23.984h4.2v-.958h-4.2Zm4.669,0h4.215v-.958h-4.215Z",
    transform: "translate(-223.224 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7052",
    "data-name": "Caminho 7052",
    d: "M238.258,23.984h4.208v-.958h-4.208Zm4.676,0h4.208v-.958h-4.208Z",
    transform: "translate(-219.327 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7053",
    "data-name": "Caminho 7053",
    d: "M243.711,23.984h4.208v-.958h-4.208Zm4.669,0h4.215v-.958H248.38Z",
    transform: "translate(-215.43 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7054",
    "data-name": "Caminho 7054",
    d: "M249.164,23.984h4.208v-.958h-4.208Zm4.674,0h4.208v-.958h-4.208Z",
    transform: "translate(-211.533 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7055",
    "data-name": "Caminho 7055",
    d: "M254.617,23.984h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-207.636 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7056",
    "data-name": "Caminho 7056",
    d: "M260.069,23.984h4.208v-.958h-4.208Zm4.681,0h4.2v-.958h-4.2Z",
    transform: "translate(-203.74 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7057",
    "data-name": "Caminho 7057",
    d: "M265.526,23.984h4.2v-.958h-4.2Zm4.674,0h4.208v-.958H270.2Z",
    transform: "translate(-199.84 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7058",
    "data-name": "Caminho 7058",
    d: "M270.979,23.984h4.208v-.958h-4.208Zm4.674,0h4.215v-.958h-4.215Z",
    transform: "translate(-195.943 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7059",
    "data-name": "Caminho 7059",
    d: "M276.435,23.984h4.2v-.958h-4.2Zm4.669,0h4.208v-.958H281.1Z",
    transform: "translate(-192.044 16.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7060",
    "data-name": "Caminho 7060",
    d: "M281.884,23.984h4.208v-.958h-4.208Zm4.676,0h4.215v-.958H286.56Z",
    transform: "translate(-188.15 16.455)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIrn);
export default __webpack_public_path__ + "static/media/flag_IRN.129a527844d0f70ba37cdc61355e2cbb.svg";
export { ForwardRef as ReactComponent };